<form
  [formGroup]="formGroup"
  (ngSubmit)="submit()"
  autocomplete="off"
  class="entry-form"
>
  <box class="field-set">

    <app-credit-transaction-period-list
      class="col-sm-12 col-lg-12 col-md-12"
      label="Billing Period"
      placeholder="Billing Period"
      formControlName="transactionPeriod"
    ></app-credit-transaction-period-list>

    <ng-container *ngIf="_responsive.isMobile()">
      <ng-container *ngIf="state.ismonthOrDate == 'MONTH'">
      <div class="yearmonthbx">
      <div  class="year-set">
        <div class="col-sm-12 col-lg-12 col-md-12">
        <app-durationlist
          label="Year"
          placeholder="Year"
          formControlName="period"
          ngModel

        ></app-durationlist>
      </div></div>

    </div>  
    </ng-container>
    </ng-container>
    <ng-container>
      <div class="date-container" *ngIf="state.ismonthOrDate == 'PERIOD'">
      
        <div class="year-set" >
          <app-durationlist class="col-sm-12 col-lg-12 col-md-12"
            label="Period"
            placeholder="Period"
            formControlName="period"
            ngModel

          ></app-durationlist>
        </div> 

      </div>
    </ng-container>

    <ng-container *ngIf="state.isDownloadFormat == 'PDF'">
    <app-DisDownformatlist
      class="col-sm-12 col-lg-12 col-md-12"
      label="Display/DownloadFormat"
      placeholder="Display/DownloadFormat"
      formControlName="displayDownloadFormat"
    ></app-DisDownformatlist>
  </ng-container>
  </box>

  <ng-container *ngIf="_responsive.isMobile()">
    <div class="filter-form-btn">
      <box class="filter-form-btn-grp2">
        <button
          *ngIf="formGroup"
          type="button"
          (click)="_helper.submitForm()"
          class="button-common button40 active"
          [disabled]="!formGroup.valid || state.isDateValid"
        >
          <span>{{ mode == "MODIFY" ? "Update" : "Submit" }}</span>
        </button>
      </box>
      <box class="filter-form-btn-grp1">
        <button
          type="button"
          class="btn-link"
          [ngClass]="{
            'btn-visibility-hidden': !state.showReset
          }"
          (click)="_helper.reset()"
        >
          <span class="reset-btn">Reset</span>
        </button>
      </box>
    </div>
  </ng-container>
</form>
<ng-container *ngIf="!_responsive.isMobile()">
  <div class="filter-form-btn">
    <box class="filter-form-btn-grp2">
      <button
        type="button"
        class="btn-link"
        [ngClass]="{
          'btn-visibility-hidden': !state.showReset
        }"
        (click)="_helper.reset()" 
      >
        <span class="reset-btn">Reset</span>
      </button>
      <button
        *ngIf="formGroup"
        type="button"
        (click)="_helper.submitForm()"
        class="button-common button40 active"
        [disabled]="!formGroup.valid || state.isDateValid"
      >
        <span>{{ mode == "MODIFY" ? "Update" : "Submit" }}</span>
      </button>
    </box>
  </div>
</ng-container>
